import { render, staticRenderFns } from "./TaskDueDateCell.vue?vue&type=template&id=435ac90e"
import script from "./TaskDueDateCell.vue?vue&type=script&lang=js"
export * from "./TaskDueDateCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports